import React from 'react'
import { Redirect, Switch, withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LOGIN_ROUTE } from '../constants/auth'
import { savePostLoginRedirect } from '../actions'
import AnalyticsRoute from './AnalyticsRoute'
import LoginContainer from './login/LoginContainer'
import GroupHomepageContainer from './homepage/GroupHomepageContainer'
import GlobalAttentionContainer from './globalattention/GlobalAttentionContainer'
import HomepageContainer from './homepage/HomepageContainer'
import LibraryContainer from './library/LibraryContainer'
import SubscriberContainer from './subscriber/SubscriberContainer'
import AudienceContainer from './audience/AudienceContainer'
import GroupTrackerContainer from './tracker/GroupTrackerContainer'
import TrackerContainer from './tracker/TrackerContainer'
import UMapExplorerContainer from './umap/UMapExplorerContainer'
import GroupRediscoverContainer from './rediscover/GroupRediscoverContainer'
import RediscoverContainer from './rediscover/RediscoverContainer'
import CalendarContainer from './calendar/CalendarContainer'
import GroupAudienceAcquisitionContainer from './acquisition/GroupAudienceAcquisitionContainer'
import AudienceAcquisitionContainer from './acquisition/AudienceAcquisitionContainer'
import AttentionContainer from './attention/AttentionContainer'
import DashboardContainer from './dashboard/DashboardContainer'
import FaqComponent from '../components/faq/FaqComponent'
import NotFound from '../components/NotFound'
import BudgetSubscribersContainer from './budgetsubscribers/BudgetSubscribersContainer'
import ChatBotContainer from './aiinsights/ChatBotContainer'
import TrendingContainer from './trending/TrendingContainer'

class RequireAuth extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired
    //setCurrentPath: PropTypes.func
  }

  componentDidUpdate (previousProps) {
    if (previousProps.location.pathname !== this.props.location.pathname) {
    // this.props.setCurrentPath(this.props.location.pathname)
    }
  }

  render () {
    if (!this.props.isLoggedIn) {
      this.props.dispatch(savePostLoginRedirect(this.props.location.pathname))
      return (<Redirect to={LOGIN_ROUTE} />)
    } else {
      return (
        <div>
          <Switch>
            <AnalyticsRoute
              exact path='/'
              component={LoginContainer} />
            <AnalyticsRoute
              exact path='/insights/homepage'
              component={GroupHomepageContainer} />
            <AnalyticsRoute
              exact path='/insights/homepage/:topicId'
              component={HomepageContainer} />
            <AnalyticsRoute
              exact path='/insights/library'
              component={LibraryContainer} />
            <AnalyticsRoute
              exact path='/insights/subscriber/:subscriberId'
              component={SubscriberContainer} />
            <AnalyticsRoute
              exact path='/insights/audience/:topicId/:type'
              component={AudienceContainer} />
            <AnalyticsRoute
              exact path='/insights/tracker'
              component={GroupTrackerContainer} />
            <AnalyticsRoute
              exact path='/insights/tracker/:trackerId'
              component={TrackerContainer} />
            <AnalyticsRoute
              exact path='/insights/discover'
              component={UMapExplorerContainer} />
            <AnalyticsRoute
              exact path='/insights/rediscover'
              component={GroupRediscoverContainer} />
            <AnalyticsRoute
              exact path='/insights/rediscover/:topicId'
              component={RediscoverContainer} />
            <AnalyticsRoute
              exact path='/insights/calendar/:month/:day/:year'
              component={CalendarContainer} />
            <AnalyticsRoute
              exact path='/insights/acquisition'
              component={GroupAudienceAcquisitionContainer} />
            <AnalyticsRoute
              exact path='/insights/acquisition/:topicId/:type'
              component={AudienceAcquisitionContainer} />
            <AnalyticsRoute
              exact path='/insights/attentionindex'
              component={GlobalAttentionContainer} />
            <AnalyticsRoute
              exact path='/insights/attention'
              component={AttentionContainer} />
            <AnalyticsRoute
              exact path='/insights/dashboard/:category'
              component={DashboardContainer} />
            <AnalyticsRoute
              exact path='/insights/budget'
              component={BudgetSubscribersContainer} />
            <AnalyticsRoute
              exact path='/insights/faq'
              component={FaqComponent} />
            <AnalyticsRoute
              exact path='/insights/chatbot'
              component={ChatBotContainer} />
            <AnalyticsRoute
              exact path='/insights/trendingtopics'
              component={TrendingContainer} />
            <AnalyticsRoute
              path='*'
              component={NotFound} />
          </Switch>
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    isLoggedIn: state.user.isLoggedIn
  }
}

export default connect(mapStateToProps)(withRouter(RequireAuth))
